
<template>
  <div>
    <div
      v-show="showVue"
      style="width: 1300px; margin: 0 auto; margin-top: 50px"
    >
      <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888">
        <p class="mt-2 mb-2 font">
          <img
            src="../../static/images/kucun.png"
            style="width: 1.5rem; height: 1.5rem"
            class="mb-lg-1"
            alt=""
          />
          <span
            class="p-1"
            style="
              text-shadow: #000 1px 0 0;
              background-color: #3190e8;
              color: #fff;
              box-shadow: 6px 4px 9px #888888;
              font-family: Helvetica Neue, Tahoma, Arial;
              border-radius: 3px;
            "
          >
            促销品种管理
          </span>
          <span
            class="float-right span_close"
            style="
              display: block;
              width: 20px;
              line-height: 20px;
              text-align: center;
              font-size: 25px;
              margin-right: 6px;
            "
            @click="$router.go(-1)"
          >
            &times;
          </span>
        </p>

        <div
          class="mb-2"
          style="margin-left: 20px; display: flex; align-items: center"
        >
          <span>序列号:</span>
          <input
            type="text"
            class="input_form-control ml-2"
            v-model="gatherNo"
          />
          <!--<span class="ml-2"> 客户名称: </span>
          <input
            type="text"
            class="input_form-control ml-2"
            v-model="customerName"
          />-->
          <span class="ml-2">药品名称:</span>
          <input
            type="text"
            class="input_form-control ml-2"
            v-model="drugName"
          />
          <button
            class="bg-primary button_zi heit ml-2"
            @click="getClerkStoreGoodsQuery()"
          >
            查询
          </button>
        </div>
        <table v-if="showPage" class="table table-striped table-hover">
          <thead>
            <tr style="white-space: nowrap" class="text-center">
              <th>序列号</th>
              <!-- <th>客户名称</th> -->
              <th>库区</th>
              <th>药品名称</th>
              <th>产地</th>
              <th>规格</th>
              <th>进价</th>
              <th style="color: green">批量价</th>
              <!-- <th>批零价</th> -->
              <th>单价</th>
              <th>数量</th>
              <th>金额</th>
              <th>批准文号</th>
              <th>包装</th>
              <th>批号</th>
              <th>远程订单</th>
              <!-- <th>库存id</th> -->
              <th>修改价格</th>
              <th>确认修改</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in tableData" :key="index">
              <td class="jz_middle">{{ item.gatherNo }}</td>
              <!--  <td class="jz_middle">{{ item.customerName }}</td> -->
              <td class="jz_middle">
                {{ item.storeNo }}
              </td>
              <td class="jz_middle">
                {{ item.drugName }}
              </td>
              <td class="jz_middle">{{ item.factory }}</td>
              <td class="jz_middle">{{ item.spec }}</td>
              <td class="jz_middle">{{ item.purchPrice }}</td>
              <td class="jz_middle" style="color: green">
                {{ item.tradePrice }}
              </td>
              <!-- <td class="jz_middle">{{item.retailPrice}}</td> -->
              <td class="jz_middle">{{ item.price }}</td>
              <td class="jz_middle">{{ item.num }}</td>
              <td class="jz_middle">{{ item.amount }}</td>
              <td class="jz_middle">{{ item.approvalNo }}</td>
              <td class="jz_middle">{{ item.pack }}</td>
              <td class="jz_middle">{{ item.batchNo }}</td>
              <td class="jz_middle">{{ item.state | status }}</td>
              <!-- <td class="jz_middle">{{item.storeID}}</td> -->
              <td class="jz_middle">
                <input
                  type="text"
                  class="text-center"
                  style="width: 60px"
                  v-model="item.value"
                />
              </td>
              <td class="jz_middle">
                <button
                  class="bg-primary button_zi heit"
                  @click="GetTiaoJia(index)"
                >
                  确认
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-else>
          <img
            src="../../static/images/wushuju.jpg"
            style="width: 300px; height: 300px; display: block; margin: 0 auto"
            alt=""
          />
        </div>

        <p class="text-center">
          <img
            src="../../static/images/tuding.png"
            style="width: 1.5rem; height: 1.5rem"
            alt=""
          />
        </p>
      </div>
    </div>
    <!-- 详情内容 -->
    <div>
      <transition name="fade">
        <loading v-show="isLoading"> </loading>
      </transition>
    </div>
    <!-- 这里是弹出调价框 -->
    <div
      class="modal fade"
      id="myModal_jia"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div
          class="modal-content"
          style="width: 100%; position: relative; top: 150px; min-width: 500px"
        >
          <div class="modal-header">
            <button
              type="button"
              class="close m-0 p-1"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="card">
              <div class="card-header">
                <div class="font">
                  <span class="ml-2"> 以前的批量价为 </span>
                  <span style="color: blue; font-weight: bold" class="ml-2">
                    {{ BeforePrice }}
                  </span>
                  <span class="ml-2"> 修改批量价为 </span>
                  <span style="color: red; font-weight: bold" class="ml-2">
                    {{ ModifyPrice }}
                  </span>
                </div>
              </div>
              <div class="card-body">
                <div>
                  <!-- <p>
                    <select v-model="phoneNumber" class="input_form-control1">
                      <option value="">请选择手机号码</option>
                      <option
                        v-for="(item, index) in phones"
                        :key="index"
                        :value="item.tel"
                        v-text="item.tel"
                      ></option>
                    </select>

                    <button
                      class="btn btn-primary ml-5"
                      :disabled="disabled"
                      @click.prevent="getCode()"
                    >
                      {{ btnText }}
                    </button>
                  </p> -->
                  <p class="mt-4">
                   <span>二级密码:</span>
                    <input
                      type="text"
                      class="input_form-control1"
                      placeholder="请输入二级密码"
                      v-model="securityCode"
                    />
                    <el-link href="/secondpass">忘记密码?</el-link>
                  </p>
                  <p class="text-center mt-4">
                    <button
                      class="btn btn-primary"
                      :disabled="disabled1"
                      @click="Modification()"
                    >
                      确认修改此价格
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              <span aria-hidden="true"></span>关闭
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vPagination from "../components/Pagination.vue";
import Loading from "../components/Loading.vue";
import { async } from "q";
export default {
  name: "SaleQuery",
  data() {
    return {
      searchForm: {
        supplierNum: "",
      }, //搜索内容
      isLoading: false,
      tableData: [],
      Record: "", //总记录数
      Pcount: "", //总页数
      PageNo: 1, //当前页码
      showPage: true,
      details: [],
      totalLimitMoney: "",

      total: 1, // 记录总条数
      display: 20, // 每页显示条数
      current: 1, // 当前的页数

      gatherNo: "", //序列号

      ModifyPrice: "", //修改价格的值

      BeforePrice: "", //之前的价格

      id: "",
      gatherNoCount: "",
      StoreNo: "",
      storeID: "",
      state: "",

      index: "",
      customerName: "",
      netOrderNo: "",
      drugName: "",
      showVue: false,

      totalCount: 0,
      phoneNumber: "", //选中的手机号码
      securityCode: "", //验证码
      phones: [],
      disabled: false,
      disabled1: false,
    };
  },
  components: {
    vPagination,
    Loading,
  },
  computed: {
    btnText() {
      return this.totalCount !== 0
        ? `${this.totalCount}秒再次获取`
        : "获取验证码";
    },
  },
  filters: {
    //过滤器时间转换
    //时间转换
    formatUTC: function (utc_datetime) {
      return utc_datetime.replace(/T/gi, "  ").substring(0, 20);
    },

    status: function (status) {
      if (status == 4) {
        return "远程订单";
      } else {
        return "线下";
      }
    },
  },

  methods: {
    //获取短信验证码

    getCode() {
      const that = this;
      //  console.log(that.phoneNumber)
      let reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
      if (!that.phoneNumber) {
        alert("输入的手机号码不能为空！");
      } else if (!reg.test(that.phoneNumber)) {
        alert("您输入的手机号码有错误！");
      } else {
        that.getsendMessage();
      }
    },
    getsendMessage: async function () {
      //按钮120秒倒计时
      await this.sendMessage(); //120秒倒计时过后才能调用事件
      if (this.success) {
        this.totalCount = 120;
        this.disabled = true;
        this.interval = setInterval(() => {
          this.totalCount--;
          if (this.totalCount === 0) {
            clearInterval(this.interval);
            this.disabled = false;
          }
        }, 1000);
      }
    },
    sendMessage: async function () {
      const that = this;
      await that.$http
        .post("/Dls/addaccount", { phone: that.phoneNumber })
        .then((response) => {
          //  console.log(response)
          if (response.data.isOk) {
            that.success = true;
            // alert("信息已发送，请注意查收")
            that.$message.success("信息已发送，请注意查收!");
          } else if (!response.data.isOk) {
            if (response.data.errorMessage == -3) {
              alert("发送一次短信可以使用1天，1天内不需要发送新短信");
            } else if (response.data.errorMessage == -4) {
              alert("短信发送失败，请联系管理员！");
            }
          }
        });
    },

    //确认修改
    Modification: async function () {
      const that = this;
      let reg1 = /^[0-9]{6}$/;
      if (!that.securityCode) {
        alert("您的二级密码为空！");
      } else if (that.securityCode.length!=6) {
        alert("您输入的验证码位数有误！");
      } else {
        that.disabled1 = true;
        await that.$http
          .post("/Dls/SaleOrderTradePriceAdjustNew", {
            id: that.id,
            upPrice: that.ModifyPrice,
            gatherNo: that.gatherNoCount,
            StoreNo: that.StoreNo,
            storeID: that.storeID,
            state: that.state,
            netOrderNo: that.netOrderNo,
            phone: that.phoneNumber,
            yzm: that.securityCode,
          })
          .then((response) => {
            //console.log(response)
            if (response.data.isOk) {
              if (response.data.data.isSucceed) {
                $("#myModal_jia").modal("hide");
                that.disabled1 = false;
                alert(response.data.data.msg);
                //重新赋值
                this.tableData[this.index].amount = response.data.data.amount;
                this.tableData[this.index].price = response.data.data.price;
                this.tableData[this.index].tradePrice =
                  response.data.data.tradePrice;
              } else {
                that.disabled1 = false;
                alert(response.data.data.msg);
              }

              //这里重新获取列表

              // that.getClerkStoreGoodsQuery();
            } else if (!response.data.isok) {
              that.disabled1 = false;
              alert(response.data.message);
            }
          });
      }
    },

    //这里是传入价格，并且对价格进行判断
    GetTiaoJia: async function (index) {
      this.index = index;
      const that = this;
      that.ModifyPrice = that.tableData[index].value;
      that.BeforePrice = that.tableData[index].tradePrice;
      that.id = that.tableData[index].id;
      that.gatherNoCount = that.tableData[index].gatherNo;
      that.StoreNo = that.tableData[index].StoreNo;
      that.storeID = that.tableData[index].storeID;
      that.state = that.tableData[index].state;
      that.netOrderNo = that.tableData[index].netOrderNo;

      let reg = /^(?!0+$)(?!0*\.0*$)\d{1,5}(\.\d{1,3})?$/;
      if (!that.ModifyPrice) {
        alert("您输入的价格不能为空！");
      } else if (!reg.test(that.ModifyPrice)) {
        alert("输入价格不能带负数，必须为纯数字，小数点最多三位！");
      } else if (that.ModifyPrice >= that.BeforePrice) {
        alert("价格只能调低!");
      } else {
        //这里先判断有没有手机号

        await that.isPhones();
      }
    },

    //判读是否有手机号
    isPhones() {
      const that = this;
      that.$http.post("/Dls/GetPhone", {}).then((response) => {
        //  console.log(response)
        if (response.data.isOk) {
          that.phones = response.data.data.rows;
          // console.log(that.phones)

          $("#myModal_jia").modal();
        } else {
          alert(response.data.message);
        }
      });
    },

    searchEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.Search();
      }
    },

    getClerkStoreGoodsQuery: async function () {
      // this.isLoading=true;
      const { data: res } = await this.$http.post("Dls/getFun", {
        action: "SaleOrderAdjustSearch",
        obj: JSON.stringify({
          gatherNo: this.gatherNo.trim(),
          customerName: this.customerName.trim(),
          drugName: this.drugName.trim(),
        }),
      });
      // console.log(res)
      if (res.isok) {
        this.showVue = true;
        const obj = res.data;
        this.tableData = obj.rows;
        if (this.tableData.length > 0) {
          this.showPage = true;
        } else {
          this.showPage = false;
        }
      }
    },
  },
  mounted() {},
  created() {
    this.getClerkStoreGoodsQuery();
  },
};
</script>
<style scoped>
.table-hover > tbody > tr:hover {
  background-color: #dee2e6 !important;
}
.font {
  font-size: 15px;
}
.font_yz {
  font-size: 1px;
  color: red;
}
.button_zi {
  text-shadow: #000 1px 0 0;
  border-radius: 5px;
  border: none;
  color: azure;
}
.heit {
  height: 1.5rem;
}
.span_close:hover {
  color: #3190e8;
}

.autocut {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  -khtml-text-overflow: ellipsis;
  -moz-text-overflow: ellipsis;
  -webkit-text-overflow: ellipsis;
}
.jz_middle {
  vertical-align: middle;
}
.input_form-control {
  /* // display: block;  */
  width: 20%;
  height: 24px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.428571429;
  color: #555555;
  vertical-align: middle;
  background-color: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s,
    box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
.input_form-control:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
}
.input_form-control:disabled {
  border: 1px solid #ddd;
  background-color: #f5f5f5;
  color: #aca899;
  opacity: 1;
}

.input_form-control1 {
  /* // display: block;  */
  width: 50%;
  height: 38px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.428571429;
  color: #555555;
  vertical-align: middle;
  background-color: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s,
    box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
.input_form-control1:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
}
.input_form-control1.button_zi {
  border: 1px solid #ddd;
  background-color: #f5f5f5;
  color: #aca899;
  opacity: 1;
}
</style>


// WEBPACK FOOTER //
// src/pages/OrderManagement.vue